import queryString from 'query-string';

import { saveTemporaryStorageAndGenerateRedirectURL } from 'utils/temporaryStorage';

const getThirdPartyLoginUrl = async ({
  provider,
  redirectTo,
  inviteId,
  savedListing,
  subscribedSubsite,
}: {
  provider: 'facebook' | 'google';
  redirectTo: string | null | undefined;
  inviteId?: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savedListing: Record<string, any> | null | undefined;
  subscribedSubsite: string | null | undefined;
}) => {
  const queryParams = {};
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'provider' does not exist on type '{}'.
  queryParams.provider = provider;

  if (inviteId) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'invite' does not exist on type '{}'.
    queryParams.invite = inviteId;
  }

  if (savedListing || subscribedSubsite) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-param-reassign
    redirectTo = await saveTemporaryStorageAndGenerateRedirectURL(redirectTo, {
      // @ts-expect-error ts-migrate(2739) FIXME: Type 'Record<string, any>' is missing the followin... Remove this comment to see the full error message
      listing: savedListing,
      subscribedSubsiteId: subscribedSubsite,
    });
  }

  if (redirectTo) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'to' does not exist on type '{}'.
    queryParams.to = redirectTo;
  }

  return `/third-party-login?${queryString.stringify(queryParams)}`;
};

// eslint-disable-next-line import/no-default-export
export default getThirdPartyLoginUrl;
